/**
 * 系统消息组件
 */

import React from 'react';
import type { ChatMessage } from '../../../types';

interface SystemMessageProps {
  message: ChatMessage;
}

export const SystemMessage: React.FC<SystemMessageProps> = React.memo(({ message }) => (
  <div className="flex items-center justify-center my-3 gap-2">
    <div className="flex-1 max-w-[60px] border-t border-[#E5E0D8]" />
    <span className="text-xs text-[#9CA3AF] whitespace-nowrap">{message.text}</span>
    <div className="flex-1 max-w-[60px] border-t border-[#E5E0D8]" />
  </div>
));

SystemMessage.displayName = 'SystemMessage';
